import { Box } from '@components/Box';
import { JoykitColor } from '@components/themes';
import { themeColor, themeSpace } from '@utils/styledTheme.util';
import React, { FC } from 'react';
import styled from 'styled-components';

const StyledProgressBar = styled(Box)<{ fillColor: JoykitColor; progressWidth: string }>`
  width: 100%;
  height: ${themeSpace(3)};
  border-radius: 100px;
  position: relative;
  ::after {
    content: '';
    display: block;
    height: 100%;
    width: ${(props) => props.progressWidth};
    background-color: ${(props) => themeColor(props.fillColor)};
    border-radius: 100px;
  }
`;

interface ProgressBarProps {
  backgroundColor: JoykitColor;
  fillColor: JoykitColor;
  progressWidth: string;
}

export const ProgressBar: FC<ProgressBarProps> = (props) => {
  const { backgroundColor = 'white', fillColor, progressWidth } = props;
  return <StyledProgressBar backgroundColor={backgroundColor} fillColor={fillColor} progressWidth={progressWidth} />;
};
